import React from "react";
import { FiPhone, FiMapPin } from "react-icons/fi";

import TextileBackground from "../../components/TextileBackground";
import CinematicSection from "../../components/CinematicSection";
import CustomNavbar from "../../components/Navbar";
import Reveal from "../../components/Reveal";
import FooterLinks from "../../components/FooterLinks";
import Footer from "../../components/Footer";
import company from "../../data/company";

const locations = [
  {
    id: 1,
    name: "Sutramay Factory — Pune",
    address: company.address,
    info: "Our garment manufacturing facility — sampling, production, and finishing.",
    phones: [
      { display: company.phone, raw: company.phoneRaw },
      { display: company.phoneAlt, raw: company.phoneAltRaw },
    ],
  },
];

export default function Locations() {
  return (
    <TextileBackground>
      <CustomNavbar />

      <CinematicSection zIndex={10} className="bg-cream-100/60" trackHeight="46vh" fitContent>
        <header className="px-6 text-center">
          <Reveal>
            <p className="font-accent italic text-maroon-700 text-base tracking-[0.3em] uppercase mb-3">
              Where We Craft
            </p>
          </Reveal>
          <Reveal delay={150}>
            <div className="flex items-center justify-center gap-4">
              <h1 className="font-heading text-maroon-800 text-4xl sm:text-5xl font-semibold">Unit Location</h1>
            </div>
          </Reveal>
          <Reveal delay={300}>
            <p className="font-body text-maroon-900/90 text-sm sm:text-base leading-relaxed max-w-2xl mx-auto mt-4">
              Visit or reach out to any of our production facilities directly.
            </p>
          </Reveal>
        </header>
      </CinematicSection>

      <CinematicSection zIndex={20} className="bg-cream-100/60" overflowY="auto" trackHeight="114vh" fitContent>
        <div className="max-w-3xl mx-auto px-6 py-10">
          <div className="grid grid-cols-1 gap-8">
            {locations.map((loc, i) => (
              <Reveal key={loc.id} delay={i * 150}>
                <section className="bg-cream-50 border-2 border-gold-500/40 rounded-2xl overflow-hidden shadow-md">
                  <div className="w-full h-64">
                    <iframe
                      title={loc.name}
                      src={`https://maps.google.com/maps?q=${encodeURIComponent(loc.address)}&z=15&output=embed`}
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                    ></iframe>
                  </div>
                  <div className="p-6">
                    <h2 className="font-heading text-maroon-700 text-xl font-medium">{loc.name}</h2>
                    <p className="font-body text-maroon-900/90 text-sm mt-1 leading-relaxed">{loc.address}</p>
                    <p className="font-body text-maroon-900/85 text-xs mt-2 leading-relaxed">{loc.info}</p>
                    <div className="flex flex-wrap items-center gap-x-4 gap-y-2 font-body text-maroon-700 font-semibold text-xs mt-4 border-t border-gold-500/30 pt-3">
                      <FiPhone className="text-sm shrink-0" />
                      {loc.phones.map((p, idx) => (
                        <a key={p.raw} href={`tel:${p.raw}`} className="hover:underline">
                          {p.display}
                          {idx < loc.phones.length - 1 && <span className="mx-2 text-maroon-700/40">·</span>}
                        </a>
                      ))}
                    </div>
                    <a
                      href={company.mapsDirectionsUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center gap-1.5 mt-3 font-accent font-medium text-xs sm:text-xs tracking-wide uppercase text-gold-700 hover:underline"
                    >
                      <FiMapPin className="text-xs" /> Get Directions
                    </a>
                  </div>
                </section>
              </Reveal>
            ))}
          </div>

          <p className="text-center font-body text-maroon-900/90 text-sm leading-relaxed mt-10">
            For general enquiries, email us at{" "}
            <a href={`mailto:${company.email}`} className="text-maroon-700 font-semibold hover:underline">
              {company.email}
            </a>
          </p>
        </div>
      </CinematicSection>

      <FooterLinks />
      <Footer />
    </TextileBackground>
  );
}
